
/**
 * @description
 *  Lista de permisos posibles obtenidos desde el backend. El uso de este
 *  'enum' evita errores de tipeo al indicar los permisos disponibles o
 *  requeridos en algún componente.
 */

export enum BackendPermission {

    Basket,
    Branding,
    Calendar,
    Campaign,
    Zone,
    CampaignLevel,
    CampaignProducts,
    CanCancelOrder,
    CanCheckoutOrder,
    CanConfigDebt,
    CanCreateBasket,
    CanCreateBrandingConfiguration,
    CanCreateCalendar,
    CanCreateCampaign,
    CanCreateCampaignLevel,
    CanCreateCampaignProducts,
    CanCreateCampaignProductsSuggested,
    CanCreateCommunication,
    CanCreateDebt,
    CanCreateEditionOrders,
    CanCreateGift,
    CanCreateLeaderLevel,
    CanCreateMaterial,
    CanCreateMaterialBasic,
    CanCreateMaterialPosition,
    CanCreateMaterialReplacement,
    CanCreateMaterialStock,
    CanCreateMaterialStockReal,
    CanCreateOrder,
    CanCreateOrderEvent,
    CanCreateOrderEventItem,
    CanCreateOrderEventMassive,
    CanCreateOrderEventTracking,
    CanCreateOrderItem,
    CanCreateProduct,
    CanCreateProductGroup,
    CanCreateProductMaterial,
    CanCreatePromotion,
    CanCreateReach,
    CanCreateRole,
    CanCreateTransport,
    CanCreateUser,
    CanDeleteCalendar,
    CanDeleteCampaign,
    CanDeleteCampaignProducts,
    CanDeleteCommunication,
    CanDeleteGift,
    CanDeleteLeaderLevel,
    CanDeleteMaterial,
    CanDeleteMaterialReplacement,
    CanDeleteOrderEvent,
    CanDeleteOrderItem,
    CanDeleteProduct,
    CanDeleteProductGroup,
    CanDeletePromotion,
    CanDeleteReach,
    CanDeleteRole,
    CanDeleteCampaignLevel,
    CanDeleteTransportRoute,
    CanEditBasket,
    CanEditCalendar,
    CanEditCampaign,
    CanEditCampaignProducts,
    CanEditCampaignLevel,
    CanEditCommission,
    CanEditCommunication,
    CanEditDebt,
    CanEditEntornoLogistico,
    CanEditLeaderLevel,
    CanEditOrder,
    CanEditProduct,
    CanEditProductGroup,
    OnlyEditImageProduct,
    CanEditPromotion,
    CanEditReach,
    CanEditReferrer,
    CanEditResellerStatus,
    CanEditFirstCampaign,
    CanEditRole,
    CanEditTransport,
    CanEditUser,
    CanEnqueue,
    CanGenerateInvoicingPrintFiles,
    CanFilterUserArea,
    CanFilterUserDivision,
    CanFilterUserZone,
    CanReceivedOrderEventsProducts,
    CanDeleteOrderCanceled,
    CanUploadGZCollection,
    CanUploadTransportCollection,
    CanViewBasket,
    CanViewCalendar,
    CanViewCampaign,
    CanViewCampaignLevel,
    CanViewCampaignProducts,
    CanViewCampaignProductsSuggested,
    CanViewCommunication,
    CanViewDebt,
    CanViewEditionOrders,
    CanViewGift,
    CanViewIndicators,
    CanRegenerateIndicators,
    CanViewInvoicedFoxProducts,
    CanViewInvoicing,
    CanViewLeaderLevel,
    CanViewMaterial,
    CanViewMaterialBasic,
    CanViewMaterialForecast,
    CanViewMaterialPosition,
    CanViewMaterialReplacement,
    CanViewMaterialStock,
    CanViewMaterialStockReal,
    CanViewNoStock,
    CanViewNoStockProducts,
    CanViewOrder,
    CanViewOrderEvent,
    CanViewOrderEventMassive,
    CanViewOrderEventMassiveList,
    CanViewOrderEventResult,
    CanViewOrderEventType,
    CanViewOrdersTransaction,
    CanViewOwnIndicators,
    CanViewProduct,
    CanViewProductCategory,
    CanViewProductForecast,
    CanViewProductGroup,
    CanViewProductMaterial,
    CanViewProductType,
    CanViewPromotion,
    CanViewRanking,
    CanViewReach,
    CanViewRealStockMaterialLog,
    CanViewStatement,
    CanViewStockMaterialLog,
    CanViewTransport,
    CanViewUser,
    Commission,
    Communication,
    Configuration,
    Debt,
    Gift,
    Indicators,
    Invoicing,
    LeaderLevel,
    Order,
    OrderEvent,
    Orders,
    Product,
    ProductGroup,
    Promotion,
    Ranking,
    Reach,
    RoleManagement,
    Sales,
    SalesForce,
    Security,
    Statement,
    Stock,
    Transport,
    UserManagement,
    CanScanAllBoxes,
    CanViewCloseButton,
    Scope,
    CanCreateScope,
    CanEditScope,
    CanDeleteScope,
    Points,
    CanViewPoints,
    CanEditPoints,
    CanViewPointsResellerHistory,
    CanUploadMassiveDataLoad,

    // Permisos temporales para UI:
    UI,
    FrontOffice,
    CanViewMenuButtonSalesFront,
    CanViewMenuSalesFrontResellers,
    CanViewMenuSalesFrontCRMResellers,
    CanViewMenuSalesFrontBuyIntention,
    CanViewMenuSalesFrontKPI,
    CanViewMenuSalesFrontChangesClaimsAndCreditNotes,
    CanViewMenuSalesFrontChangesAndClaimsControl,
    CanViewMenuSalesFrontReturnsChangesAndClaimsAndCreditNotesControl,
    CanViewMenuSalesFrontCommunications,
    CanViewMenuSalesFrontNews,
    CanViewMenuSalesFrontWebAdvertising,
    CanViewMenuButtonSales,
    CanViewMenuSalesCampaigns,
    CanViewMenuSalesCommercialStructure,
    CanViewMenuSalesProductOffer,
    CanViewMenuSalesCommissions,
    CanViewMenuSalesProducts,
    CanViewMenuSalesPromotions,
    CanViewMenuSalesScopes,
    CanViewMenuSalesProductStructure,
    CanViewMenuSalesLeaderLevels,
    CanViewMenuSalesMaterialsStock,
    CanViewMenuSalesInvoicingStockProjection,
    CanViewMenuSalesCatchmentStockProjection,
    CanViewMenuSalesCatchmentWithoutPointsStockProjection,
    CanViewMenuSalesReports,
    CanViewMenuSalesRanking,
    CanViewMenuSalesNoStockReports,
    CanViewMenuPoints,
    CanViewMenuButtonOrders,
    CanViewMenuOrdersShoppingCart,
    CanViewMenuOrdersOrdersList,
    CanViewMenuOrdersInvoicing,
    CanViewMenuOrdersCollection,
    CanViewMenuOrdersTransportRegistration,
    CanViewMenuOrdersOrdersAndDebts,
    CanViewMenuOrdersPrizes,
    CanViewMenuButtonPicking,
    CanViewMenuPickingMaterialsWithStockLocation,
    CanViewMenuPickingMaterialsOutOfPicking,
    CanViewMenuPickingBoxScan,
    CanViewMenuPickingTransport,
    CanViewMenuPickingTransportSettlement1,
    CanViewMenuButtonSecurity,
    CanViewMenuSecurityRoles,
    CanViewMenuButtonConfiguration,
    CanViewMenuConfigurationDebt,
    CanViewMenuConfigurationPickingBoxes,
    CanViewMenuConfigurationTransporters,
    CanViewMenuConfigurationLogisticEnvironment,
    CanViewMenuConfigurationBranding,
    CanViewMenuConfigurationGuapaAndExtraBrochure,
    CanViewMenuConfigurationMap,

    // Nuevos permisos para NC/CyR:
    CanDownloadOrderEventsByReseller,
    CanDownloadOrderEventsByZone,
    CanUploadOrderEventsByReseller,
    CanUploadOrderEventsByZone,

    // Nuevos permisos para NC/CyR OrderEventBasket:
    CanCanEditOrderEventBasket,
    CanReopenOrderEventBasket,
    CanUpdateOrderEventBasket,
    CanDownloadOrderEventBasketReceptionSheet,
    CanDownloadOrderEventBasketBalance,
    CanDownloadOrderEventBasketResume,

    //  Nuevos permisos para oferta de productos:
    CanDownloadProducts,
    CanUploadProducts,
    CanDownloadSuggestedAndReplacements,
    CanUploadSuggestedAndReplacements,

    // Nuevos permisos de stock de materiales:
    CanDownloadMaterials,
    CanUploadMaterials,
    CanDownloadMaterialsOnly,
    CanUploadMaterialsOnly,
    CanDownloadStockProjection,
    CanDownloadPickingMaterials,
    CanUploadPickingMaterials,
    CanDownloadStockMaterials,
    CanDownloadStockMaterialsWithoutPoints,
    CanUploadStockMaterials,
    CanDownloadKardexStock,
    CanDownloadRealKardexStock,
    CanDownloadRealStock,
    CanUploadRealStock,
    CanDownloadProductMaterials,
    CanUploadProductMaterials,
    CanDownloadMaterialReplacements,
    CanUploadMaterialReplacements,

    // Nuevos permisos para reportes de morosidad:
    CanDownloadDelinquencyReportByCampaign,
    CanDownloadDelinquencyReportByReseller,

    // Pagos
    CanUploadPayment,
    CanDeletePayment,
    CanViewMovements,
    CanViewAllStatements,

    // Asignación y eliminación de roles a una cuenta:
    CanAssignRoles,
    CanDeleteAssignedRole,

    // Listado de Pedidos
    CanRealeseOrders,
    CanImportDetails,
    CanReverseDisarm,

    // Reportes en listado de usuarios
    CanDownloadUserLevelChanges,
    CanDownloadUsersInactiveReport,
    CanDownloadResellersReport,

    //CRM
    CanEditGeolocalizateZone,

    // Carrito
    CanCreateOrderForAnotherUser,

    // Para verificar control de caja:
    CanCheckIfThereWillBeControl,

    // Para bloquear usuarios:
    CanBlockUser,

    // Para anular validaciones de NC:
    CanOverrideCreditNoteValidations,

    // Para migrar estructuras comerciales:
    CanMigrateCommercialStructure,

    // Dialog Campaign Product:
    CanEditReOrderQuantity,

    // Mapa
    CanUploadZones,
    // Para baja del programa de puntos
	PointsProgramClosed
}
